import { Directive, ElementRef, EventEmitter, NgZone, OnDestroy, OnInit, Output } from '@angular/core';
import { ResizedEvent } from './ResizedEvent';

@Directive({
	selector: '[vbResized]',
    standalone: false
})
export class VbResizedDirective implements OnInit, OnDestroy {
	private observer: ResizeObserver;
	private oldRect?: DOMRectReadOnly;

	@Output()
	public readonly vbResized = new EventEmitter<ResizedEvent>();;

	public constructor(
		private readonly element: ElementRef,
		private readonly zone: NgZone
	) {}

	public ngOnInit(): void {
		this.observer = new ResizeObserver(entries => this.zone.run(() => this.observe(entries)));
		this.zone.runOutsideAngular(() => {
			this.observer.observe(this.element.nativeElement);
		});
	}

	public ngOnDestroy(): void {
		this.observer.disconnect();
	}

	private observe(entries: ResizeObserverEntry[]): void {
		const domSize = entries[0];
		const resizedEvent = new ResizedEvent(domSize.contentRect, this.oldRect);
		this.oldRect = domSize.contentRect;
		this.vbResized.emit(resizedEvent);
	}
}
